<template>
	<div class="gold-member" v-wechat-title="$route.meta.title">
		<div v-bind:class="{ overlay: overlay }"></div>
		<specialDiscount></specialDiscount>
		<premiumHeader></premiumHeader>

		<div class="body">
			<div :class="{ title: true, 'title-dimond': premiumDimond }"><div class="title-name">Get Trucker Path Premium</div></div>
			<div class="content">
				<div class="account">
					<div class="account-name">
						<div class="div-inline">Create or use your Trucker Path Account</div>
						<div class="tooltip-item div-inline">
							<img src="../../assets/images/question-mark.png" />
							<span class="tooltip-text"
								>Please use this email to log in Trucker Path to enjoy the premium, we will create an account and send the initial password by using this email if you don't have an account with us.
							</span>
						</div>
					</div>
					<div class="input-area">
						<div class="input-item">
							<input type="text" autocomplete="off" :class="{ 'input-btn': true, 'email-error': !emailValidate }" placeholder="*Email" v-model="emailInput" />
							<div :class="{ hidden: true, 'error-hint': !emailValidate }">Please input a valid email.</div>
						</div>
						<div class="input-item">
							<input type="text" autocomplete="off" :class="{ 'input-btn': true, 'email-error': !phoneValidate }" placeholder="*Phone Number" v-model="phoneInput" />
							<div :class="{ hidden: true, 'error-hint': !phoneValidate }">Please input your phone number.</div>
						</div>
						<div class="input-item">
							<input type="text" autocomplete="off" :class="{ 'input-btn': true, 'email-error': !firstNameValidate }" placeholder="*First Name" v-model="firstNameInput" />
							<div :class="{ hidden: true, 'error-hint': !firstNameValidate }">Please input your name.</div>
						</div>
						<div class="input-item">
							<input type="text" autocomplete="off" :class="{ 'input-btn': true, 'email-error': !lastNameValidate }" placeholder="*Last Name" v-model="lastNameInput" />
							<div :class="{ hidden: true, 'error-hint': !lastNameValidate }">Please input your name.</div>
						</div>
					</div>
				</div>
				<div class="premium-plan">
					<div class="premium-plan-name">Premium Plan</div>
					<div class="intro">Your premium service will start once your payment is received</div>
					<div class="select-plan">
						<div :class="{ 'plan-detail': true, 'plan-detail-shadow': selectedPlan == optionsList[0].key }" v-if="optionsList.length > 0" @click="selectPlan(optionsList[0].key, optionsList[0].pay_duration)">
							<div class="month-year">Montly</div>
							<div class="cost cost-month">
								<div class="cost-unit">$</div>
								<div :class="{ 'cost-money': true, 'bg-0': optionsList[0].price == 0, 'bg-9-99': optionsList[0].price == monthyPrice }"></div>
								<div class="old-cost">{{ monthyPrice }}</div>
							</div>
							<div class="first-bill">{{ `Your first $${monthyPrice} bill will start 7 days later` }}</div>
							<div class="renewal-time">First renewal: {{ renewDateMonth }}</div>
							<div :class="{ select: true, 'grey-select': selectedPlan != optionsList[0].key, 'blue-select': selectedPlan == optionsList[0].key }">Select</div>
						</div>
						<div :class="{ 'plan-detail': true, 'plan-detail-shadow': selectedPlan == optionsList[1].key }" v-if="optionsList.length > 0" @click="selectPlan(optionsList[1].key, optionsList[1].pay_duration)">
							<div class="month-year">Yearly</div>
							<div class="cost cost-year">
								<div class="cost-unit">$</div>
								<div :class="{ 'cost-money': true, 'bg-0': optionsList[1].price == 0, 'bg-99-99': optionsList[1].price == yearlyPrice }"></div>
								<div class="old-cost">{{ yearlyPrice }}</div>
							</div>
							<div class="first-bill">{{ `Your first $${yearlyPrice} bill will start 7 days later` }}</div>
							<div class="renewal-time">First renewal: {{ renewDateYear }}</div>
							<div :class="{ select: true, 'grey-select': selectedPlan != optionsList[1].key, 'blue-select': selectedPlan == optionsList[1].key }">Select</div>
						</div>
					</div>
					<hr />
					<div class="term-of-service">
						Please find our term of service here for your reference:
						<a href="https://truckerpath.com/terms-of-service/" target="_blank"> <span>Term of Service</span></a>
						<img src="@/assets/images/pay-info.png" alt="payment method" />
					</div>
					<div class="pay-info">
						<div>Pay with your credit card via Stripe</div>
						<img src="@/assets/images/pay-info.png" alt="payment method" />
					</div>
					<div class="accept">
						<div class="accept-item item-bottom-margin">
							<input type="checkbox" v-model="acceptTermofService" />
							<div class="item-content">
								I have read and accept the
								<a href="https://truckerpath.com/terms-of-service/" target="_blank"> <span class="stripe">Term of Service</span></a>
							</div>
						</div>
						<div class="accept-item">
							<input type="checkbox" v-model="acceptStripe" />
							<div class="item-content">
								I have read and accept <a href="https://stripe.com/ssa" target="_blank"><span class="stripe">Stripe Payment Terms</span></a>
							</div>
						</div>
						<div :class="{ 'hidden-error': true, 'error-hint': !acceptValidate }">Please read and accept our terms.</div>
					</div>
					<div id="submit-premium" :class="{ 'submit-premium': true, 'gold-bg-img': true, 'dimond-bg-img': premiumDimond, 'loading-stripe': loadingStripe }" @click="submit()">
						<img v-if="loadingStripe" src="../../assets/images/loading-bg.png" />
						<span v-if="!loadingStripe">START MY TRUCKER PATH PREMIUM</span>
						<span v-if="loadingStripe">LOADING</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getOptionsListAsync, addGoldMemberOrder, addPaymentToOrder } from '../../api/goldMember'
import moment from 'moment'
import premiumHeader from './premiumHeader.vue'
import specialDiscount from './specialDiscount.vue'
import gaSevice from '@/utils/initGA.js'

export default {
	props: {
		premiumType: {
			type: String,
			default: 'gold'
		},
		monthyPrice: {
			type: Number,
			default: 9.99
		},
		yearlyPrice: {
			type: Number,
			default: 99.99
		}
	},
	data() {
		return {
			emailInput: '',
			emailValidate: true,
			phoneInput: '',
			phoneValidate: true,
			firstNameInput: '',
			firstNameValidate: true,
			lastNameInput: '',
			lastNameValidate: true,
			acceptValidate: true,
			acceptTermofService: false,
			acceptStripe: false,
			validatePremium: false,
			selectedPlan: '',
			optionsList: [],
			renewDateMonth: moment()
				.add(7, 'days')
				.format('MMM D, YYYY'),
			renewDateYear: moment()
				.add(7, 'days')
				.format('MMM D, YYYY'),
			key: process.env.VUE_APP_STRIPE_KEY,
			canClick: true,
			order: null,
			loadingStripe: false,
			prevIframesLen: 0,
			overlay: false,
			selectedPlanPrice: 99.99,
			utmSource: this.$route.query.utm_source ? this.$route.query.utm_source : '',
			utmMedium: this.$route.query.utm_medium ? this.$route.query.utm_medium : '',
			utmCampaign: this.$route.query.utm_campaign ? this.$route.query.utm_campaign : ''
		}
	},
	components: {
		premiumHeader,
		specialDiscount
	},
	computed: {
		premiumDimond() {
			return this.premiumType === 'Diamond'
		}
	},
	beforeCreate() {
		gaSevice.addScript()
		gaSevice.init('ga3')
	},
	mounted() {
		getOptionsListAsync(this.premiumType).then(res => {
			if (res.status === 200) {
				this.optionsList = res.data.data
				this.selectedPlan = this.optionsList[1].key
			}
		})

		this.$nextTick(() => {
			const script = document.createElement('script')
			script.src = 'https://checkout.stripe.com/checkout.js'
			script.onload = script.onreadystatechange = function() {}
			document.body.appendChild(script)
		})
	},
	watch: {
		emailInput(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		},
		phoneInput(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		},
		firstNameInput(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		},
		lastNameInput(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		},
		acceptTermofService(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		},
		acceptStripe(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
			}
		}
	},
	methods: {
		selectPlan(key, duration) {
			this.selectedPlan = key
			if (duration == '1 month') {
				this.selectedPlanPrice = this.monthyPrice
			} else if (duration == '1 year') {
				this.selectedPlanPrice = this.yearlyPrice
			}
			this.validatePremium = this.emailInput && this.phoneInput && this.firstNameInput && this.lastNameInput && this.selectedPlan && this.acceptTermofService && this.acceptStripe
		},

		telephoneCheck(str) {
			let matchStr = /^((((\s|))|)\([1-9]{3}\)(\s|-|)[1-9]{3}(\s|-|)[1-9]{4})$/
			let matchStr2 = /\b\d{10}\b/g
			return str.match(matchStr) != null || str.match(matchStr2) != null
		},
		submit() {
			let reg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
			if (reg.test(this.emailInput)) {
				this.emailValidate = true
			} else {
				this.emailValidate = false
			}

			if (this.telephoneCheck(this.phoneInput)) {
				this.phoneValidate = true
			} else {
				this.phoneValidate = false
			}

			if (this.firstNameInput) {
				this.firstNameValidate = true
			} else {
				this.firstNameValidate = false
			}

			if (this.lastNameInput) {
				this.lastNameValidate = true
			} else {
				this.lastNameValidate = false
			}

			if (this.acceptTermofService && this.acceptStripe) {
				this.acceptValidate = true
			} else {
				this.acceptValidate = false
			}
			if (this.validatePremium) {
				if (this.emailValidate && this.phoneValidate) {
					this.loadingStripe = true
					const payload = {
						submit_time: moment()
							.utc()
							.format('YYYY-MM-DD HH:mm:ss'),
						product: {
							option: {
								key: this.selectedPlan
							}
						},
						account: {
							email: this.emailInput
						},
						company: '',
						phone: this.phoneInput,
						first_name: this.firstNameInput,
						last_name: this.lastNameInput,
						source: this.utmSource || '',
						medium: this.utmMedium || '',
						campaign: this.utmCampaign || ''
					}

					addGoldMemberOrder(payload).then(
						res => {
							if (res.status === 200) {
								this.order = res.data.data
								this.startStripePay(this.addCardBack.bind(this))
							}
						},
						err => {
							const errorMessage = this.emailInput + ' already is a premium user.'
							if (err.response.data.statusMessage == errorMessage) {
								alert('You already are a premium')
								this.loadingStripe = false
							} else {
								alert('Something went wrong. Please try again.')
								this.loadingStripe = false
							}
						}
					)
				}
			}
		},
		startStripePay(callBack) {
			let key = this.key
			let email = this.emailInput
			let Checkout = window.StripeCheckout
			this.canClick = false
			Checkout.configure({
				key: key,
				image: require('../../assets/images/truckerpath_logo.png'),
				locale: 'auto',
				token: callBack,
				allowRememberMe: false,
				email: email
			}).open({
				name: 'Card Information',
				panelLabel: 'Try Now'
			})

			let timerDeleteHandler = setInterval(() => {
				const iframes = window.document.body.querySelectorAll('iframe[name=stripe_checkout_app]')
				if (iframes.length > this.prevIframesLen) {
					const iframe = iframes[iframes.length - 1]
					const style = iframe.getAttribute('style')
					if (style.indexOf('display: none') > -1) {
						this.loadingStripe = false

						this.prevIframesLen++

						clearInterval(timerDeleteHandler)
						timerDeleteHandler = null
					}
				}
			}, 30)

			setTimeout(() => {
				this.canClick = true
			}, 2000)
		},
		addCardBack(token) {
			this.overlay = true
			let param = {
				token: token.id,
				pay_time: moment().format('YYYY-MM-DD h:mm:ss')
			}
			addPaymentToOrder(this.order.order_id, param).then(
				res => {
					let query = Object.keys(this.$route.query).length ? this.$route.query : {}
					gaSevice.emit('success', 'ga3', { event_label: this.selectedPlan })
					this.$router.push({
						name: 'success',
						params: { selectedPlanPrice: this.selectedPlanPrice },
						query
					})
					this.overlay = false
				},
				err => {
					gaSevice.emit('fail-server', 'ga3')
					alert('Something went wrong. Please try again.')
				}
			)
		}
	}
}
</script>

<style lang="scss" scoped>
.overlay {
	position: absolute;
	width: 100%;
	z-index: 8;
	background-color: rgba(0, 0, 0, 0.6);
	top: 0;
	left: 0;
	height: 100%;
}
.gold-member {
	textarea:focus,
	input:focus {
		outline: none;
	}
	input[type='text'] {
		height: 22px;
		font-family: OpenSans;
		font-size: 16px;
		color: #000000;
	}

	max-width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-family: OpenSans;
	.body {
		width: 650px;
		margin: 24px auto 63px auto;
		background-color: #ffffff;
		border-radius: 8px;
		.title {
			height: 107px;
			background-image: url('../../assets/images/bg.svg');
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center;
			padding: 31px 160px 43px 160px;
			.title-name {
				font-size: 24px;
				font-weight: 800;
				color: #5f3000;
				width: 330px;
				height: 33px;
				text-align: center;
			}
		}
		.title-dimond {
			background-image: url('../../assets/images/dimond-bg.svg');
		}
		.content {
			padding: 15px 40px 0 40px;
			.account {
				.account-name {
					height: 24px;
					font-size: 18px;
					font-weight: 600;
					color: #000000;
					img {
						width: 16px;
						height: 16px;
						object-fit: contain;
					}
					.div-inline {
						display: inline;
					}
					.tooltip-item {
						margin-left: 4px;
						vertical-align: middle;
						position: relative;
						.tooltip-text {
							width: 300px;
							height: 105px;
							font-size: 12px;
							color: #000000;
							position: absolute;
							padding: 10px 30px 10px 40px;
							right: -285px;
							top: -38px;
							background-image: url('../../assets/images/tooltip.png');
							background-size: cover;
							background-repeat: no-repeat;
							background-position: center;
							object-fit: contain;
							visibility: hidden;
						}
					}
					.tooltip-item:hover .tooltip-text {
						visibility: visible;
					}
				}
				.input-area {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					padding: 10px 0 2px 0;
					border-bottom: solid 1px #dfdfdf;
					.input-btn {
						margin-bottom: 22px;
						width: 273px;
						height: 44px;
						border-radius: 4px;
						background-color: #ededed;
						padding-left: 15px;
						border: solid 1px #ededed;
					}
					input::-webkit-input-placeholder {
						color: #737373;
						width: 121px;
						height: 22px;
						font-size: 16px;
					}
					input::-moz-placeholder {
						color: #737373;
						width: 121px;
						height: 22px;
						font-size: 16px;
					}
					input:-moz-placeholder {
						color: #737373;
						width: 121px;
						height: 22px;
						font-size: 16px;
					}
					input:-ms-input-placeholder {
						color: #737373;
						width: 121px;
						height: 22px;
						font-size: 16px;
					}
					.email-error {
						border: solid 1px #dc1400;
						background-color: #ffeeee;
					}
					.hidden {
						height: 17px;
						font-size: 12px;
						color: #dc1400;
						text-align: right;
						margin: -22px 0 3px 0;
						visibility: hidden;
					}
					.error-hint {
						visibility: visible;
					}
				}
			}
			.premium-plan {
				.premium-plan-name {
					margin: 24px 0 5px 0;
					font-size: 18px;
					font-weight: 600;
					color: #000000;
					width: 128px;
					height: 24px;
				}
				.intro {
					width: 570px;
					height: 17px;
					font-size: 12px;
					font-weight: 600;
					color: rgba(0, 0, 0, 0.5);
					margin-bottom: 12px;
				}
				.select-plan {
					// height: 275px;
					display: flex;
					justify-content: space-between;
					.plan-detail {
						width: 273px;
						height: 275px;
						border-radius: 6px;
						border: solid 1px #dfdfdf;
						padding: 16px 15px 24px 15px;
						.month-year {
							width: 59px;
							height: 22px;
							font-size: 16px;
							font-weight: 800;
							color: #676767;
						}
						.cost-month {
							margin: 20px auto 14px auto;
						}
						.cost-year {
							margin: 20px auto 14px auto;
						}
						.cost {
							display: flex;
							justify-content: center;
							height: 87px;
							.cost-unit {
								height: 33px;
								font-size: 24px;
								font-weight: 600;
								color: #ababab;
								margin: 9px 4px 0 0;
							}
							.cost-money {
								height: 87px;
								line-height: 87px;
								font-family: DINAlternate !important;
								font-size: 75px;
								font-weight: bold;
								color: #000000;
							}
							.bg-0 {
								background-image: url('../../assets/images/0-00.png');
								background-size: 121px 55px;
								background-repeat: no-repeat;
								background-position: center;
								width: 126px;
							}
							.bg-9-99 {
								background-image: url('../../assets/images/9-99.png');
								background-size: 121px 55px;
								background-repeat: no-repeat;
								background-position: center;
								width: 126px;
							}
							.bg-99-99 {
								background-image: url('../../assets/images/99-99.png');
								background-size: 157px 54px;
								background-repeat: no-repeat;
								background-position: center;
								width: 162px;
							}
							.old-cost {
								font-size: 18px;
								font-weight: 600;
								color: #910000;
								text-decoration: line-through;
								align-self: flex-end;
								margin: 0 0 16px 10px;
							}
						}
						.first-bill {
							height: 17px;
							width: 250px;
							font-size: 12px;
							font-weight: 600;
							color: rgba(0, 0, 0, 0.6);
							text-align: left;
						}
						.renewal-time {
							width: 243px;
							height: 17px;
							font-size: 12px;
							font-weight: 600;
							color: #000000;
							margin-bottom: 16px;
						}
						.select {
							width: 243px;
							height: 40px;
							line-height: 40px;
							border-radius: 4px;
							font-size: 16px;
							font-weight: 600;
							text-align: center;
							cursor: pointer;
						}
						.grey-select {
							background-color: #d8d8d8;
							color: #000000;
						}
						.blue-select {
							background-color: #2380f5;
							color: #ffffff;
						}
					}
					.plan-detail-shadow {
						box-shadow: 0 2px 20px 0 rgba(0, 55, 115, 0.13);
						border: none;
					}
				}
				hr {
					margin: 22px 0 24px 0;
					background: #dfdfdf;
					border: none;
					height: 1px;
				}
				.term-of-service {
					font-size: 14px;
					font-weight: 600;
					color: #4d4d4d;
					span {
						color: #2380f5;
						text-decoration: underline;
						cursor: pointer;
					}
					img {
						display: none;
					}
				}
				.pay-info {
					margin: 8px 0 8.6px 0;
					height: 22.4px;
					line-height: 22.4px;
					font-size: 14px;
					font-weight: 600;
					color: #4d4d4d;
					display: flex;
					img {
						width: 160px;
						height: 22.4px;
						object-fit: contain;
						margin-left: 10px;
					}
				}
				.accept {
					display: flex;
					flex-direction: column;
					.accept-item {
						display: flex;
						height: 17px;
						line-height: 17px;
						input {
							width: 16px;
							height: 16px;
							border-radius: 2px;
							border: solid 1px #c3c3c3;
							margin: 1px 9px 1px 0;
							cursor: pointer;
						}
						.item-content {
							height: 17px;
							font-size: 12px;
							font-weight: 600;
							color: #000000;
							.stripe {
								color: #2380f5;
								text-decoration: underline;
								cursor: pointer;
							}
						}
					}
					.item-bottom-margin {
						margin-bottom: 10px;
					}
					.hidden-error {
						height: 17px;
						font-size: 12px;
						color: #dc1400;
						margin: 3px 0 0 25px;
						visibility: hidden;
					}
					.error-hint {
						visibility: visible;
					}
				}
				.submit-premium {
					width: 297px;
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					font-weight: bold;
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					text-align: center;
					margin: 12px auto 30px auto;
					img {
						width: 23px;
						height: 22px;
						object-fit: contain;
						vertical-align: middle;
						margin-right: 9.4px;
						animation: que 4s linear infinite;
					}
					@keyframes que {
						0% {
							transform: rotate(0deg);
						}
						100% {
							transform: rotate(360deg);
						}
					}
				}
				.gold-bg-img {
					color: #683500;
					background-image: url('../../assets/images/gold-button-pre.png');
					cursor: pointer;
				}
				.dimond-bg-img {
					background-image: url('../../assets/images/dimond-button-pre.svg');
				}
				.loading-stripe {
					cursor: not-allowed;
				}
			}
		}
	}
}

@media screen and (max-width: 750px) {
	.gold-member {
		input[type='text'] {
			height: 19px;
			font-size: 14px;
		}
		.body {
			width: 345px;
			margin: 15px auto 24px auto;
			.title {
				height: 72px;
				background-size: 345px 72px;
				padding: 24px 49px;
				.title-name {
					font-size: 18px;
					height: 24px;
					width: 247px;
					text-align: center;
				}
			}
			.content {
				padding: 15px 15px 0 15px;
				.account {
					.account-name {
						height: 22px;
						font-size: 16px;
						.tooltip-item {
							display: none;
						}
					}
					.input-btn {
						margin: 8px 0 24px 0;
						width: 315px;
						height: 35px;
						padding-left: 10px;
					}
					hr {
						width: 315px;
					}
				}
				.premium-plan {
					.premium-plan-name {
						margin: 15px 0 8px 0;
						height: 22px;
						font-size: 16px;
					}
					.intro {
						width: 315px;
						height: 34px;
						margin-bottom: 15px;
					}
					.select-plan {
						flex-wrap: wrap;
						.plan-detail {
							width: 315px;
							margin-bottom: 15px;
							.select {
								width: 285px;
							}
						}
					}
					hr {
						margin: 15px 0;
					}
					.term-of-service {
						width: 315px;
						font-size: 12px;
						img {
							// visibility: visible;
							display: inline-block;
							width: 160px;
							height: 22px;
							object-fit: contain;
							// margin-top: -4px;
						}
					}
					.pay-info {
						width: 315px;
						margin: 10px 0 15px 0;
						// height: 17px;
						font-size: 12px;
						// flex-wrap: wrap;
						img {
							// margin: -5px 0 0 0;
							display: none;
						}
					}
					.accept {
						.accept-item {
							margin-bottom: 15px;
						}
					}
				}
			}
		}
	}
}
</style>
